var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (isFeatured, shows, type, undefined) {
jade_mixins["showFigureContent"] = jade_interp = function(show, isFeatured){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var posterImageUrl = show.posterImageUrl(isFeatured) || ""
buf.push("<div" + (jade.attr("style", "background-image: url(" + (posterImageUrl) + ")", true, true)) + " class=\"partner2-show-cover-image\"><img" + (jade.attr("src", "" + (posterImageUrl) + "", true, true)) + (jade.attr("alt", show.formatFeedItemHeading(), true, true)) + "><div class=\"partner2-show-overlay\"></div></div><figurecaption class=\"partner2-show-caption\"><h5 class=\"partner2-show-heading\">" + (jade.escape(null == (jade_interp = show.formatLeadHeading()) ? "" : jade_interp)) + "</h5>");
if ( show.has('artists'))
{
buf.push("<h3 class=\"partner2-show-artists\">" + (jade.escape(null == (jade_interp = show.formatArtists()) ? "" : jade_interp)) + "</h3>");
}
buf.push("<h4 class=\"partner2-show-name\">" + (jade.escape(null == (jade_interp = show.formatFeedItemHeading()) ? "" : jade_interp)) + "</h4><h6 class=\"partner2-show-time\">" + (jade.escape(null == (jade_interp = show.runningDates()) ? "" : jade_interp)) + "</h6></figurecaption>");
};
var slicedShows = shows.slice(0,30)
// iterate slicedShows
;(function(){
  var $$obj = slicedShows;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var show = $$obj[$index];

buf.push("<figure" + (jade.attr("data-show-id", show.get('id'), true, true)) + " class=\"partner2-show grid-item\">");
if ( show.get('displayable'))
{
buf.push("<a" + (jade.attr("href", show.href(), true, true)) + ">");
jade_mixins["showFigureContent"](show, isFeatured);
buf.push("</a>");
}
else
{
jade_mixins["showFigureContent"](show, isFeatured);
}
buf.push("</figure>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var show = $$obj[$index];

buf.push("<figure" + (jade.attr("data-show-id", show.get('id'), true, true)) + " class=\"partner2-show grid-item\">");
if ( show.get('displayable'))
{
buf.push("<a" + (jade.attr("href", show.href(), true, true)) + ">");
jade_mixins["showFigureContent"](show, isFeatured);
buf.push("</a>");
}
else
{
jade_mixins["showFigureContent"](show, isFeatured);
}
buf.push("</figure>");
    }

  }
}).call(this);

if ( shows.length > 30)
{
buf.push("<a" + (jade.attr("data-show-type-id", type, true, true)) + " class=\"avant-garde-button-white is-block js-partner-shows-more\">Show More</a><div class=\"loading-spinner\"></div>");
}}.call(this,"isFeatured" in locals_for_with?locals_for_with.isFeatured:typeof isFeatured!=="undefined"?isFeatured:undefined,"shows" in locals_for_with?locals_for_with.shows:typeof shows!=="undefined"?shows:undefined,"type" in locals_for_with?locals_for_with.type:typeof type!=="undefined"?type:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;